import { useRouter } from "../../util/router"

const useIsFromMOF = () => {
  const router = useRouter()
  return router.query.from === "preview"
}

export default useIsFromMOF
